require('./loanMovementsDetail.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
//@helpers
const { formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTableRowDetails = require('components/rebrand/OKTableRowDetails/OKTableRowDetails');
const OKTableRowDetailsItem = require('components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
//@commons
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@actions
const { requestLoanMovementsDetails } = require('../../../../actions/loansMovementsDetails');

class LoanMovementsDetail extends React.Component {

    constructor(props) {
        super(props);

        this.getDetails = this.getDetails.bind(this);
    }

    componentDidMount() {
        this.getDetails();
    }

    getDetails() {
        const { immTransaction, requestLoanMovementsDetails } = this.props;
        requestLoanMovementsDetails(immTransaction.get('id'));
    }

    buildContent() {
        const { immTransaction } = this.props;
        const immDetails = immTransaction.getIn(['details', 'details']);
        const plainAmountFeeObject = getPlainAmountObject(immDetails.get('feeAmount'));
        const plainAmountCapitalObject = getPlainAmountObject(immDetails.get('capital'));
        const plainAmountInterestObject = getPlainAmountObject(immDetails.get('interest'));
        const language = getLanguage();

        const feeImportAmount = (
            <OneLineSymbolAmount
                amountObject={plainAmountFeeObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountFeeObject, true)} />
        );
        const capitalAmount = (
            <OneLineSymbolAmount
                amountObject={plainAmountCapitalObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountCapitalObject, true)} />
        );
        const interestsAmount = (
            <OneLineSymbolAmount
                amountObject={plainAmountInterestObject}
                language={language}
                amountObjectFormatted={formatAmountObject(plainAmountInterestObject, true)} />
        );

        return (
            <OKTableRow>
                <OKTableCell />
                <OKTableCell colSpan={5}>
                    <OKTableRowDetails title="loanMovements-detail">
                        <OKTableRowDetailsItem
                            title="loanMovements-feeImport"
                            value={feeImportAmount} />
                        <OKTableRowDetailsItem
                            title="loanMovements-capital"
                            value={capitalAmount} />
                        <OKTableRowDetailsItem
                            title="loanMovements-interests"
                            value={interestsAmount} />
                    </OKTableRowDetails>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildErrorState() {
        const primaryText = formatText('loanMovements-detailsErrorMessage');

        return (
            <OKTableRow>
                <OKTableCell colSpan={7}>
                    <div className="loan-movements-details__error-state">
                        <EmptyState primaryText={primaryText} iconType="nointernet-banking"/>
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildLoadingSection() {
        return (
            <OKTableRow>
                <OKTableCell />
                <OKTableCell colSpan={5}>
                    <div className="loan-movements-details__loading-section">
                        <LoadingSection />
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }


    render() {
        const { immTransaction } = this.props;
        const immDetails = immTransaction.get('details');
        let content;

        if (immDetails.get('isFetching')) {
            content = this.buildLoadingSection();
        } else if (immDetails.get('error')) {
            content = this.buildErrorState();
        } else {
            content = this.buildContent();
        }

        return content;
    }
}

LoanMovementsDetail.propTypes = {
    immTransaction: PropTypes.object,
    requestLoanMovementsDetails: PropTypes.func.isRequired
};

module.exports = connect(null, { requestLoanMovementsDetails })(LoanMovementsDetail);
